<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Pengumuman">
            <common-training-header/>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px"><a-button v-if="roleAdmin" type="primary" icon="plus" block @click="showModal('')"> Tambah Pengumuman</a-button></a-col>
        </a-row>

        <a-card type="inner" size="small">
            <template v-if="roleAdmin">
                <a-table
                    class="pcp-table"
                    :dataSource="items.data"
                    rowKey="hash"
                    :loading="loading"
                    :pagination="false"
                    bordered>

                    <a-table-column key="title" title="Title" className="align-center text-small text-left">
                        <template slot-scope="record">
                           {{ record.title }}
                        </template>
                    </a-table-column>

                    <a-table-column key="description" title="Uraian" className="align-center text-small text-left">
                        <template slot-scope="record">
                           {{ record.description | truncate(20, '...')  }}
                        </template>
                    </a-table-column>

                    <a-table-column key="is_active" title="Status" className="align-center text-small text-center">
                        <template slot-scope="record">
                           <a-tag
                                :color="record.is_active == true ? 'green' : 'red'"
                            >
                                {{
                                    record.is_active == true
                                        ? "active"
                                        : "not active"
                                }}
                            </a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column key="is_dashboard" title="Dashboard" className="align-center text-small text-center">
                        <template slot-scope="record">
                           <a-tag
                                :color="record.is_dashboard == true ? 'green' : 'red'"
                            >
                                {{
                                    record.is_dashboard == true
                                        ? "YES"
                                        : "NO"
                                }}
                            </a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column key="attachment" title="Lampiran" className="align-center text-small text-center">
                        <template slot-scope="record">
                           <a-button type="link" size="small" @click="download(record.attachment)"
                                v-if="record.attachment != null">
                                <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                            <a-tooltip title="Reupload lampiran">
                                <a-button type="dashed" icon="upload" size="small" @click="showModalAttachment(record.hash)">
                                Reupload</a-button>
                            </a-tooltip>
                        </template>
                    </a-table-column>

                    <a-table-column key="last_update" title="Last Update" className="align-center text-small text-center">
                        <template slot-scope="record">
                           <template v-if="record.updated_at != null">
                                {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                            </template>
                        </template>
                    </a-table-column>

                    <a-table-column key="action" title="Action" className="align-center text-small text-center">
                        <template slot-scope="record">
                            <a-space>
                                <a-tooltip title="Edit Pengumuman">
                                    <a-button
                                        size="small"
                                        type="primary"
                                        icon="edit"
                                        @click="showModal(record.hash)"
                                    />
                                </a-tooltip>

                                <a-popconfirm
                                    title="Anda yakin akan menghapus data ini?"
                                    ok-text="Yes"
                                    cancel-text="No"
                                    @confirm="handleDelete(record.hash)"
                                >
                                    <a-button
                                        size="small"
                                        icon="delete"
                                        type="danger"
                                        :loading="processing"
                                        :disabled="processing"
                                    />
                                </a-popconfirm>

                                <a-tooltip title="Preview">
                                    <a-button
                                        size="small"
                                        icon="eye"
                                        @click="showModalAnnounce(record.hash)"
                                    />
                                </a-tooltip>
                            </a-space>
                        </template>
                    </a-table-column>
                </a-table>
            </template>
            <template v-else>
                <a-collapse v-for="item in items.data" :key="item.hash">
                    <a-collapse-panel :header="item.title">
                        <a-card type="inner" size="small">
                            <a-row type="flex">
                                <a-col><strong>{{ item.title }}</strong></a-col>
                            </a-row>
                            <a-row type="flex"  style="margin-top: 20px">
                                <a-col>
                                    <div v-html="item.description">
                                    </div>
                                </a-col>
                            </a-row>
                            <a-row type="flex"  style="margin-top: 20px">
                                <a-col>
                                    <a-button type="link" size="small" @click="download(record.attachment)"
                                        v-if="item.attachment != null">
                                        <a-icon type="file-pdf" theme="twoTone" two-tone-color="#eb3437" /> Download
                                    </a-button>
                                </a-col>
                            </a-row>
                        </a-card>
                    </a-collapse-panel>
                </a-collapse>
            </template>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
            width="80%"
        >
            <classical-announcement-form
                :announcement="this.announcement"
                @handleClose="closeModal"
            />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleAnnouncement"
            :closable="false"
        >
            <announcement
                :announcement="this.announcement"
                @handleClose="closeModal"
            />
        </a-modal>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visibleAttachment"
            :closable="false"
        >
            <classical-announcement-upload
                :announcement="this.announcement"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<style>
th.align-center {
    text-align: center !important;
}
th.align-left {
    text-align: center !important;
}
</style>

<script>
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            visibleAnnouncement: false,
            visibleAttachment: false,
            announcement: null,
            processing: false,
            items: {
                data: []
            },
            filters: {
                q: null,
                email: null,
                page: 1
            }
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        roleAdmin() {
            return this.$laravel.roles[this.activeModule.module.identifier] == 'admin'
        },
        tableColumns() {
            if(!this.roleAdmin) {
                this.columns.splice(1, 5)
            }

            return this.columns
        },
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.pushState(this.filters);
            this.getItems();
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.announcement'), {
                    params: this.filters
                })
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleDelete(id) {
            this.processing = true;

            this.$http
                .delete(
                    this.routeUri("api.announcement.destroy", {
                        announcement: id
                    })
                )
                .then(response => this.handleSuccessResponse(response.data))
                .catch(error => this.handleResponseError(error.response.data))
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems();
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        showModal(hash) {
            this.announcement = hash.toString();
            this.visible = true;

        },
        showModalAnnounce(hash) {
            this.announcement = hash;
            this.visibleAnnouncement = true;
        },
        showModalAttachment(hash) {
            this.announcement = hash;
            this.visibleAttachment = true;
        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visibleAnnouncement = false;
            this.visibleAttachment = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
    },
    filters: {
        truncate: function (text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix;
            } else {
                return text;
            }
        },
    }
}
</script>
